/**
 * How long a plan runs, as one sentence: `8 tygodni`, `zapętlony`, or nothing at all.
 *
 * ── Why it is in `ui/` and not in `model/` ───────────────────────────────────────────────────
 * `model/planLibraryRow`'s `PlanSpan` is the DECISION — a finite number of weeks or a loop, and
 * which of the two a plan may claim. The string is a plural, and `model/` takes a key-only
 * translate: a count cannot travel through one. So the decision is `model/`'s and the sentence is
 * this layer's, which is the split every projection in the slice already makes.
 *
 * ── Why it is a MODULE and not a local in each file ──────────────────────────────────────────
 * Two surfaces print it: the template row's whole sub-line (owner decision D26, 4 September 2026),
 * and the first part of the inspector hero's. They were the same expression written twice, so the
 * day `bez końca` comes back — the canon's dropped third spelling, D3 — one of them would get it.
 */

import type { TFunction } from 'i18next';

import type { PlanSpan } from '../model/planLibraryRow';

/** `null` for a plan with no phases: `0 tygodni` would be a figure where the truth is an absence. */
export function spanLabel(span: PlanSpan | null, t: TFunction): string | null {
  if (span === null) return null;
  return span.kind === 'weeks'
    ? t('web:planLibrary.row.spanWeeks', { count: span.weeks })
    : t('web:planLibrary.row.spanLooped');
}
